import { DEMO_CONSENT_CHILDREN } from '../../constants/demoChildren';
import type { DemoConsentChild } from '../../constants/demoChildren';
import type { SelfServiceApiContext } from './types';

interface ChildRecord {
  name: string;
  cpr: string;
}

const normalizeChildren = (input: any): ChildRecord[] => {
  if (!Array.isArray(input)) {
    return [];
  }
  return input
    .filter((child: any) => child && typeof child.name === 'string' && typeof child.cpr === 'string')
    .map((child: any) => ({ name: child.name, cpr: child.cpr }));
};

const mergeDemoChildren = (children: ChildRecord[], demoChildren: ReadonlyArray<DemoConsentChild>): ChildRecord[] => {
  if (!demoChildren.length) {
    return children;
  }
  const seen = new Set(children.map(child => child.cpr));
  const merged = [...children];
  demoChildren.forEach(demoChild => {
    if (!seen.has(demoChild.cpr)) {
      merged.push({ name: demoChild.name, cpr: demoChild.cpr });
      seen.add(demoChild.cpr);
    }
  });
  return merged;
};

export const getChildren = async (ctx: SelfServiceApiContext, opts?: { test?: boolean }): Promise<ChildRecord[]> => {
  const demoChildren: ReadonlyArray<DemoConsentChild> = opts?.test ? DEMO_CONSENT_CHILDREN : [];

  try {
    const qp = opts?.test ? '?test=true' : '';
    const response = await ctx.httpClient.getJSON(`${ctx.baseUrl}/selfservice/children${qp}`);
    if (response.ok) {
      const data = await response.json();
      const normalized = normalizeChildren(data?.children);
      if (normalized.length > 0) {
        return mergeDemoChildren(normalized, demoChildren);
      }
    }
  } catch {
    // ignore network errors in mock mode
  }

  if (demoChildren.length > 0) {
    return demoChildren.map(child => ({ name: child.name, cpr: child.cpr }));
  }
  return [];
};

export const __testUtils = {
  normalizeChildren,
  mergeDemoChildren
};


